export default "__VITE_ASSET__BhpIE7Yu__"